import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./components/add-new-post/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";


import Class from "./components/Class/Class";
import Subject from "./components/Subject/Subject";
import Faculty from './components/Faculty/Faculty';
import Exam from './components/Examination/Exam';
import Student from './components/Student/Student';
import HomeWork from './components/HomeWork/HomeWork';
import TimeTable from './components/TimeTable/TimeTable';
import Attendance from './components/Attendance/Attendance';
import Fees from './components/Fees/Fees';
import Message from './components/Messaging/Message';
import Result from './components/Result/Result';
import Login from './components/Login/Login';

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect  to="/class" />
  },
  {
    path:'/login',
    layout: DefaultLayout,
    component:Login
  },
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview
  },
  {
    path: "/class",
    layout:DefaultLayout,
    component : Class
  },
  {
    path: "/fees",
    layout:DefaultLayout,
    component : Fees
  },
  {
    path : "/subject",
    layout:DefaultLayout,
    component : Subject
  },
  {
    path : "/faculty",
    layout:DefaultLayout,
    component : Faculty
  },
  {
    path : "/message",
    layout:DefaultLayout,
    component : Message
  },
  {
    path : "/result",
    layout:DefaultLayout,
    component : Result
  },
  {
    path : "/exam",
    layout:DefaultLayout,
    component : Exam
  },
  {
    path : "/student",
    layout:DefaultLayout,
    component : Student
  },
  {
    path : '/homework',
    layout : DefaultLayout,
    component : HomeWork
  },
  {
    path : '/attendance',
    layout : DefaultLayout,
    component : Attendance
  },
  {
    path : "/timetable",
    layout:DefaultLayout,
    component : TimeTable
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts
  }
];
